import { render, staticRenderFns } from "./compose-kepu.vue?vue&type=template&id=22dea722"
import script from "./compose-kepu.vue?vue&type=script&lang=ts"
export * from "./compose-kepu.vue?vue&type=script&lang=ts"
import style0 from "./compose-kepu.vue?vue&type=style&index=0&id=22dea722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports